import {
  blockquote,
  callout,
  bold,
  code,
  codeBlock,
  doc,
  heading,
  horizontalRule,
  italic,
  lineBreak,
  link,
  list,
  listItem,
  paragraph,
  strikethrough,
  subscript,
  superscript,
  table,
  tableDataCell,
  tableRow,
  text,
  underline,
  image,
  mention,
  file,
  highlight,
  embed,
  math_inline,
  math_display,
} from '../schema';
import { Schema } from 'prosemirror-model';

// for server side authority Instance
export const marks = {
  bold,
  highlight,
  code,
  italic,
  link,
  strikethrough,
  subscript,
  superscript,
  underline,
}
export const nodes = {
  text, // plain text node
  doc, // top-level node
  paragraph, // paragraph must be the first node type of the "block" group
  lineBreak,
  heading,
  blockquote,
  callout,
  codeBlock,
  horizontalRule,
  list,
  listItem,
  table,
  tableRow,
  tableDataCell, // tableDataCell must be the first node type of the "tableCell" group
  image,
  file,
  mention,
  embed,
  math_inline,
  math_display,
}

export const schema = new Schema({
  marks: marks,
  nodes: nodes,
});

export type MySchema = typeof schema;
